import type { RouteRecordRaw } from 'vue-router';
import ManageProfilePage from './pages/ManageProfilePage/ManageProfilePage.vue';
import ManageSecurityPage from './pages/ManageSecurityPage/ManageSecurityPage.vue';
import ManageBillingPage from './pages/ManageBillingPage/ManageBillingPage.vue';

export const main: RouteRecordRaw[] = [
  {
    name: 'settings.profile',
    path: 'profile',
    component: ManageProfilePage,
    meta: {
      requiresAuth: true,
      headerTitle: 'PROFILE_SETTINGS',
    },
  },
  {
    name: 'settings.security',
    path: 'security',
    component: ManageSecurityPage,
    meta: {
      requiresAuth: true,
      headerTitle: 'SECURITY_SETTINGS',
    },
  },
  {
    name: 'settings.billing',
    path: 'billing',
    component: ManageBillingPage,
    meta: {
      requiresAuth: true,
      headerTitle: 'BILLING_SETTINGS',
    },
  },
];

export const school: RouteRecordRaw[] = [];

export const base: RouteRecordRaw[] = [];
